<template>
  <div class="records-container">
    <div class="header">
      <button class="back-btn" @click="goBack">← 返回首页</button>
      <h1 class="title">我的抽奖记录</h1>
    </div>

    <div class="content">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>正在加载记录...</p>
      </div>

      <!-- 记录列表 -->
      <div v-else-if="records.length > 0" class="records-list">
        <div 
          v-for="record in records" 
          :key="record.id"
          class="record-card"
        >
          <div class="record-header">
            <div class="record-date">{{ formatDate(record.createTime) }}</div>
            <div :class="['record-status', record.prizesState]">
              {{ record.prizesState === 1 ? '中奖' : '未中奖' }}
            </div>
          </div>
          
          <div class="record-content">
            <div class="prize-info">
              <!-- <div class="prize-icon">{{ record.prizesImg }}</div> -->
              <img class="prize-icon" :src="record.prizesImg" alt="奖品图标">
              <div class="prize-details">
                <h3 class="prize-name">{{ record.prizesName }}</h3>
                <p v-if="record.prizesState === 1" class="prize-level">
                  {{ getPrizeLevelText(record.awardsName) }}
                </p>
              </div>
            </div>
            
            <div class="record-number">
              <span class="label">抽奖编号：</span>
              <span class="value">{{ record.code }}</span>
            </div>
          </div>
          
          <div v-if="record.prizesState === 1" class="record-footer">
            <div class="claim-status" :class="record.recieveStatus">
              {{ record.recieveStatus === 1 ? '已领取' : '待领取' }}
            </div>
            <!-- <button 
              v-if="record.claimStatus === 'pending'" 
              class="claim-btn"
              @click="claimPrize(record.id)"
            >
              领取奖品
            </button> -->
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <div class="empty-icon">🎫</div>
        <h3>暂无抽奖记录</h3>
        <p>完成答题挑战，即可参与抽奖</p>
        <button class="start-btn" @click="startQuiz">
          立即开始
        </button>
      </div>
    </div>

    <div class="footer">
      <p>© 2023 机器人知识挑战赛 | 活动最终解释权归主办方所有</p>
    </div>

    <!-- 领取成功提示 -->
    <div v-if="showClaimSuccess" class="success-toast">
      ✅ 领取成功！
    </div>
  </div>
</template>

<script>
import globalStore from '../utils/globalStore.js';
import { prizeAPI } from '../utils/api';

export default {
  name: 'Records',
  data() {
    return {
      loading: true,
      records: [],
      showClaimSuccess: false
    }
  },
  created() {
    this.fetchRecords()
  },
  methods: {
    // 获取抽奖记录
    async fetchRecords() {
      try {
        this.loading = true
        // 实际项目中应该调用真实的API
         const response = await prizeAPI.getLotteryRecords(globalStore.getUrlParams())
        
        // 模拟API调用延迟
        await new Promise(resolve => setTimeout(resolve, 1000))
        if(response.code==0 && response.data){
            this.records =response.data || []
        }

        // 模拟数据
      //  this.records = this.getMockRecords()
      } catch (error) {
        //console.error('获取抽奖记录失败:', error)
        // 发生错误时使用模拟数据
        this.records = this.getMockRecords()
      } finally {
        this.loading = false
      }
    },
    
    // 模拟抽奖记录数据
    getMockRecords() {
      return [
        {
          id: 1,
          date: new Date(Date.now() - 86400000), // 昨天
          status: 'win',
          prizeName: '机器人周边T恤',
          prizeLevel: 'second',
          prizeIcon: '👕',
          drawNumber: 'LOT20231201001',
          claimStatus: 'pending'
        },
        {
          id: 2,
          date: new Date(Date.now() - 172800000), // 前天
          status: 'win',
          prizeName: 'AI智能音箱',
          prizeLevel: 'third',
          prizeIcon: '🎵',
          drawNumber: 'LOT20231130005',
          claimStatus: 'claimed'
        },
        {
          id: 3,
          date: new Date(Date.now() - 259200000), // 3天前
          status: 'lose',
          prizeName: '未中奖',
          prizeLevel: null,
          prizeIcon: '🎯',
          drawNumber: 'LOT20231129003',
          claimStatus: null
        }
      ]
    },
    
    // 格式化日期
    formatDate(date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    
    // 获取奖项等级文本
    getPrizeLevelText(level) {
      const levelMap = {
        'first': '一等奖',
        'second': '二等奖',
        'third': '三等奖',
        'lucky': '幸运奖'
      }
      return levelMap[level] || ''
    },
    
    // 领取奖品
    async claimPrize(recordId) {
      try {
        // 实际项目中应该调用真实的API
        // await api.claimPrize(recordId)
        
        // 模拟API调用延迟
        await new Promise(resolve => setTimeout(resolve, 800))
        
        // 更新本地数据
        const record = this.records.find(r => r.id === recordId)
        if (record) {
          record.claimStatus = 'claimed'
        }
        
        // 显示成功提示
        this.showClaimSuccess = true
        setTimeout(() => {
          this.showClaimSuccess = false
        }, 2000)
      } catch (error) {
        //console.error('领取奖品失败:', error)
        alert('领取失败，请稍后重试')
      }
    },
    
    // 返回首页
    goBack() {
      this.$router.push({path: '/', query: globalStore.getUrlParams()})
    },
    
    // 开始答题
    startQuiz() {
      this.$router.push({
        path: '/quiz',
        query: globalStore.getUrlParams()
      })
    }
  }
}
</script>

<style scoped>
.records-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.header {
  max-width: 800px;
  margin: 0 auto 30px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-btn {
  background: rgba(255,255,255,0.2);
  border: 2px solid rgba(255,255,255,0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.back-btn:hover {
  background: rgba(255,255,255,0.3);
  transform: translateY(-2px);
}

.title {
  font-size: 2rem;
  color: white;
  margin: 0;
  font-weight: 700;
  text-shadow: 0 4px 8px rgba(0,0,0,0.3);
}

.content {
  max-width: 800px;
  margin: 0 auto;
  min-height: 60vh;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: white;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255,255,255,0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.records-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
}

.record-card {
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  transition: transform 0.3s ease;
}

.record-card:hover {
  transform: translateY(-5px);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.record-date {
  color: #666;
  font-size: 0.9rem;
}

.record-status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.record-status.win {
  background: #e8f5e9;
  color: #4caf50;
}

.record-status.lose {
  background: #f5f5f5;
  color: #999;
}

.record-content {
  margin-bottom: 15px;
}

.prize-info {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.prize-icon {
  font-size: 2.5rem;
  background: #f8f9fa;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prize-details {
  flex: 1;
}

.prize-name {
  font-size: 1.2rem;
  color: #333;
  margin: 0 0 5px 0;
  font-weight: 600;
}

.prize-level {
  color: #ff9800;
  font-size: 0.9rem;
  margin: 0;
  font-weight: 500;
}

.record-number {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #999;
  font-size: 0.85rem;
}

.record-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.claim-status {
  font-size: 0.9rem;
  font-weight: 500;
}

.claim-status.pending {
  color: #ff9800;
}

.claim-status.claimed {
  color: #4caf50;
}

.claim-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.claim-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.empty-state {
  background: white;
  border-radius: 15px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.empty-icon {
  font-size: 5rem;
  margin-bottom: 20px;
}

.empty-state h3 {
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.empty-state p {
  color: #666;
  margin-bottom: 30px;
}

.start-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.start-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.success-toast {
  position: fixed;
  top: 50px;
  right: 50px;
  background: #4caf50;
  color: white;
  padding: 15px 25px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  animation: slideIn 0.3s ease, fadeOut 0.3s ease 1.7s;
  z-index: 1000;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.footer {
  text-align: center;
  padding: 40px 0 20px;
  color: rgba(255,255,255,0.6);
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .back-btn {
    align-self: flex-start;
  }
  
  .title {
    font-size: 1.8rem;
  }
  
  .prize-info {
    flex-direction: column;
    text-align: center;
  }
  
  .success-toast {
    right: 20px;
    left: 20px;
  }
}
</style>